// The native module resolves to ExpoManagedAppConfigModule.ios.ts on ios and to
// the null-returning stub on every other platform.
export { default as ExpoManagedAppConfigModule } from './src/ExpoManagedAppConfigModule'
export { getManagedValue } from './src/getManagedValue'
export { getUrlKey, getUrlParam } from './src/getUrlParam'
export { createConfigValues, isTruthyFlag } from './src/createConfigValues'
export type {
  ConfigEnvValues,
  ConfigSetting,
  ConfigValues,
} from './src/createConfigValues'
export type { ExpoManagedAppConfigModuleType } from './src/ExpoManagedAppConfig.types'
